export type KeyboardAction =
  | { readonly kind: "letter"; readonly letter: string }
  | { readonly kind: "backspace" }
  | { readonly kind: "clear" }
  | { readonly kind: "submit" };

export interface KeyPress {
  readonly key: string;
  readonly altKey: boolean;
  readonly ctrlKey: boolean;
  readonly metaKey: boolean;
}

export const actionForKeyPress = (
  press: KeyPress,
  offered: readonly string[],
): KeyboardAction | null => {
  if (press.altKey || press.ctrlKey || press.metaKey) return null;
  switch (press.key) {
    case "Backspace":
      return { kind: "backspace" };
    case "Escape":
      return { kind: "clear" };
    case "Enter":
      return { kind: "submit" };
    default: {
      const letter = press.key.toLowerCase();
      return offered.includes(letter) ? { kind: "letter", letter } : null;
    }
  }
};

export const editWord = (
  word: string,
  action: Exclude<KeyboardAction, { kind: "submit" }>,
): string => {
  switch (action.kind) {
    case "letter":
      return word + action.letter;
    case "backspace":
      return word.slice(0, -1);
    case "clear":
      return "";
  }
};
